import { render, staticRenderFns } from "./TabLogoOnPhoto.vue?vue&type=template&id=62d3559a&"
import script from "./TabLogoOnPhoto.vue?vue&type=script&lang=js&"
export * from "./TabLogoOnPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports